import Controller from "csi/action/Controller";
import { goToDialog } from "csi/middleware/goToDialog/goToDialogService";
import declare from "dojo/_base/declare";

export = declare(Controller, {
	/** {string} card to use in popup table dialog rather than the default card */
	dialogCardId: null,
	
	/** {StoreNames} store containing aggregate store information */
	goToDialogStore: null,

	/** {ReflectionAttribute} attribute whose value is being selected */
	rca: null,

	/**
	 * @override
	 * Open React dialog with view containing aggregate results
	 */
	preProcess(): void {
		const { m_action, goToDialogStore, rca, dialogCardId } = this;
		const av = this.getActionView(m_action.m_viewRef);
		const defView = av?.m_defView;
		const nodeUrl = av?.m_node.$URL;

		try {
			goToDialog(this, rca, false, goToDialogStore, dialogCardId, defView, nodeUrl);
		} catch (err) {
			this._onPublishError(err);
		}
	},
});
